export const MAILTOP_AUTH_TOKEN_FORM = "marketplaceMailtopAuthTokenForm";
export const MAILTOP_LISTS_FORM = "marketplaceMailtopListsForm";
export const MAILTOP_ADD_LIST_FORM = "marketplaceMailtopAddListForm";
export const MAILTOP_DELETE_LIST_FORM = "marketplaceMailtopDeleteListForm";
export const MAILTOP_EDIT_LIST_FORM = "marketplaceMailtopEditListForm";